<template>
  <div>
    <el-row :gutter="16">
      <el-col :xs="24" :sm="12">
        <el-form-item
          :label="i18n.cadastro.labels.pais"
          prop="pessoa.enderecoEstrangeiro.pais"
        >
          <el-select
            v-model="value.enderecoEstrangeiro.pais"
            filterable
            value-key="id"
            class="full-width"
            @change="handleCountryChange"
          >
            <el-option
              v-for="pais in paises"
              :key="pais.id"
              :label="pais.nomeEn"
              :value="pais"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item
          :label="i18n.cadastro.labels.cep"
          prop="pessoa.enderecoEstrangeiro.zipCode"
        >
          <el-input
            v-model="value.enderecoEstrangeiro.zipCode"
            @blur="handleZipBlur"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col :xs="24" :sm="12">
        <el-form-item
          :label="i18n.cadastro.labels.cidade"
          prop="pessoa.enderecoEstrangeiro.cidade"
        >
          <el-input
            v-model="value.enderecoEstrangeiro.cidade"
            @blur="$emit('validate-field', 'pessoa.enderecoEstrangeiro.cidade')"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item
          :label="i18n.cadastro.labels.estado"
          prop="pessoa.enderecoEstrangeiro.estado"
        >
          <el-input
            v-model="value.enderecoEstrangeiro.estado"
            @blur="$emit('validate-field', 'pessoa.enderecoEstrangeiro.estado')"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col :span="24">
        <el-form-item
          :label="i18n.cadastro.labels.descricaoEndereco"
          prop="pessoa.enderecoEstrangeiro.descricaoEndereco"
        >
          <el-input
            v-model="value.enderecoEstrangeiro.descricaoEndereco"
            @blur="
              $emit(
                'validate-field',
                'pessoa.enderecoEstrangeiro.descricaoEndereco'
              )
            "
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="16">
      <el-col :span="24">
        <el-form-item
          :label="i18n.cadastro.labels.descricaoEndereco2"
          prop="pessoa.enderecoEstrangeiro.complemento"
        >
          <el-input v-model="value.enderecoEstrangeiro.complemento"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import { EN_CADASTRO } from "@/utils/messages/interface/registrar/identificacao/cadastro";

export default {
  name: "EnderecoEstrangeiro",
  props: {
    value: {
      type: Object,
      required: true
    },
    paises: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    i18n() {
      return EN_CADASTRO;
    }
  },
  methods: {
    handleCountryChange() {
      this.$emit("validate-field", "pessoa.enderecoEstrangeiro.pais");
    },
    handleZipBlur() {
      this.$emit("validate-field", "pessoa.enderecoEstrangeiro.zipCode");
      this.fetchAddressByZip();
    },
    fetchAddressByZip() {
      const pais = this.value.enderecoEstrangeiro.pais;
      if (!pais || !this.value.enderecoEstrangeiro.zipCode) return;

      let countryCode = null;
      if (pais.sigla === "US") countryCode = "us";

      if (countryCode) {
        axios
          .get(
            `https://api.zippopotam.us/${countryCode}/${this.value.enderecoEstrangeiro.zipCode}`
          )
          .then(response => {
            if (
              response.data &&
              response.data.places &&
              response.data.places.length > 0
            ) {
              const place = response.data.places[0];
              this.value.enderecoEstrangeiro.cidade = place["place name"];
              this.value.enderecoEstrangeiro.estado = place["state"];

              this.$emit("validate-field", "pessoa.enderecoEstrangeiro.cidade");
              this.$emit("validate-field", "pessoa.enderecoEstrangeiro.estado");
            }
          })
          .catch(err => {
            console.log("Zip lookup failed or not supported", err);
          });
      }
    }
  },
  emits: ["validate-field"]
};
</script>

<style scoped>
.full-width {
  width: 100%;
}
.section-title h3 {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 20px;
  margin-top: 30px;
  color: #295661;
}
</style>
